export const classreport = [
    {
        id: "C138038",
        class: "I",
        section: "A",
        noOfStudents: 30,
        action: "View Details",
        key:1
    },
    {
        id: "C138037",
        class: "I",
        section: "B",
        noOfStudents: 25,
        action: "View Details",
        key:2
    },
    {
        id: "C138036",
        class: "II",
        section: "A",
        noOfStudents: 40,
        action: "View Details",
        key:3
    },
    {
        id: "C138035",
        class: "II",
        section: "B",
        noOfStudents: 35,
        action: "View Details",
        key:4
    },
    {
        id: "C138034",
        class: "II",
        section: "C",
        noOfStudents: 25,
        action: "View Details",
        key:5
    },
    {
        id: "C138033",
        class: "III",
        section: "A",
        noOfStudents: 30,
        action: "View Details",
        key:6
    },
    {
        id: "C138032",
        class: "III",
        section: "B",
        noOfStudents: 25,
        action: "View Details",
        key:7
    },
    {
        id: "C138031",
        class: "IV",
        section: "A",
        noOfStudents: 20,
        action: "View Details",
        key:8
    },
    {
        id: "C138030",
        class: "IV",
        section: "B",
        noOfStudents: 30,
        action: "View Details",
        key:9
    },
    {
        id: "C138029",
        class: "V",
        section: "A",
        noOfStudents: 35,
        action: "View Details",
        key:10
    }
  ];
  